import { render, staticRenderFns } from "./create.vue?vue&type=template&id=7cd96a1a&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd96a1a')) {
      api.createRecord('7cd96a1a', component.options)
    } else {
      api.reload('7cd96a1a', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=7cd96a1a&", function () {
      api.rerender('7cd96a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/e-filling/create.vue"
export default component.exports